// import injectTapEventPlugin from 'react-tap-event-plugin';
import React from 'react';
import { render } from 'react-dom';
import routes from './routes';

export const app = () => {
	if (process.env.NODE_ENV === 'development') {
		// attach react dev tools to window
		if (typeof window !== 'undefined') {
			window.React = React;
		}
	}

	// inject tap event, currently not provided by react, required by material-ui
	// injectTapEventPlugin();

	render(routes(), document.querySelector('#main'));
};

// postpone initiation of app until fonts are active (for text components that require measurement)
export const webFontConfig = {
	google: {
		families: ['Roboto'],
	},
	classes: false,
	timeout: 1000,
	active: app,
};
